import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective } from '@jsverse/transloco';

import { StoreService } from '@store/store.service';
import { LoadingSpinnerComponent } from '@shared/ui/loading-spinner/loading-spinner.component';
import { LoadingState } from '@app/utils/models/store/loading-state.model';

@Component({
  selector: 'ess-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrl: './loading-screen.component.scss',
  imports: [LoadingSpinnerComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingScreenComponent {
  loadingState$$: Signal<LoadingState>;

  constructor(private store: StoreService) {
    this.loadingState$$ = toSignal(this.store.loadingState$, { requireSync: true });
  }
}
